import React from 'react';
import '../Css/Footer.css'
import whatsapp from '../icon/icons8-whatsapp-100.png';
import facebook from '../icon/icons8-facebook-100.png';
import ig from '../icon/icons8-ig-120.png';


function Footer() {
  return (
    <div className="footer-container">
        <div className="footer-content">
            {/* Company Information
            <div className="footer-section">
            
                <div className="address">地址: 天后木星街9號永昇中心1樓 | &nbsp; </div>
                <div className="address">電話: 68108926</div>
            </div>
            */}
            <div className="footer-section">
                <div className="social-icons">
                    <div className="icon-content">
                        <a className="icon-link"
                            href="https://wa.me/85268108926" 
                            target="_blank"
                            rel="nopener noreferrer"
                            arial-label="WhatsApp"
                        >
                            <img src={whatsapp}
                                alt="Poker Tournament Association"
                                className="icon"
                            />
                            
                            &nbsp;&nbsp;WhatsApp
                        </a>
                    </div>
                    <div className="icon-content">
                        <a className="icon-link"
                            href="https://www.facebook.com/ptahongkong" 
                            target="_blank"
                            rel="nopener noreferrer"
                            arial-label="Facebook"
                        >
                            <img src={facebook}
                                alt="Poker Tournament Association"
                                className="icon"/>
                            
                            &nbsp;&nbsp;Facebook
                        </a>
                    </div>
                    <div className="icon-content">
                        <a className="icon-link"
                            href="https://www.instagram.com/ptahongkong?igsh=NTljbnhoZmZlNTk1" 
                            target="_blank"
                            rel="nopener noreferrer"
                            arial-label="Instagram"
                        >
                            <img src={ig}
                                alt="Poker Tournament Association"
                                className="icon"/>
                            
                            &nbsp;&nbsp;Instagram
                        </a>
                    </div>
                </div> 
            </div>
        </div>
         <div className="footer-bottom">
            <p>&copy; {new Date().getFullYear()} POKER TOURNAMENT ASSOCIATION. All rights reserved.</p>
        </div>    
    </div>
  )
}

export default Footer
